import { InverseHeader } from '@jouzen/ecom-components/layout';

import PageLayout from '@/app/components/PageLayout';

import AppTabsSection from './_components-redesign/AppTabsSection';
import BlogUpdatesSection from './_components-redesign/BlogUpdatesSection';
import EndCapSection from './_components-redesign/EndCapSection';
import HealthFeaturesSection from './_components-redesign/HealthFeaturesSection';
import MembershipHero from './_components-redesign/MembershipHero';
import MembersSection from './_components-redesign/MembersSection';
import SecuritySection from './_components-redesign/SecuritySection';
import Testimonials from './_components-redesign/Testimonials';
import UICollageSection from './_components-redesign/UICollageSection';
import UIScreens from './_components-redesign/UIScreens';

const ContentRedesign = () => {
  return (
    <PageLayout
      pageName="membership"
      containerProps={{
        className: 'bg-sandstone-200 text-sandstone-500',
        name: 'membership',
        padding: 'none',
      }}
    >
      <div data-cy="membership-redesign">
        <InverseHeader enter>
          <MembershipHero />
        </InverseHeader>
        <UIScreens />
        <MembersSection />
        <AppTabsSection />
        <HealthFeaturesSection />
        <Testimonials />
        <UICollageSection />
        <SecuritySection />
        <EndCapSection />
        <BlogUpdatesSection />
      </div>
    </PageLayout>
  );
};

export default ContentRedesign;
